import PageContainer from "../components/CommonComponents/PageContainer/PageContainer";
import Box from "@mui/material/Box";
import {useTheme} from "../contexts/theme";
import {useState} from "react";
import StyledPopup from "../components/CommonComponents/StyledPopup/StyledPopup";
import RestartJobTableWrapper from "../components/AdminPageContent/RestartFromTrackJob/RestartJobTableWrapper";
import StyledCollapse from "../components/CommonComponents/StyledCollapse/StyledCollapse";

export default function AdminPage() {

    const theme = useTheme();
    const [openTable, setOpenTable] = useState<boolean>(true);

    return (

        <PageContainer>


        <Box
            style={{
                width: "100%",
                height: "100%",
                overflowY: "auto",
                backgroundColor: theme.palette.blue,
            }}
        >

            <StyledCollapse title={'Restart Jobs From Tracks'} initialValue={true} onOpen={() => setOpenTable(true)} onClose={() => setOpenTable(false)}>
                <RestartJobTableWrapper/>
            </StyledCollapse>


        </Box>

    </PageContainer>)
}